import { __require as r } from "../node_modules/recharts/node_modules/react-is/index.js";
var a = r();
export {
  a as r
};
